import { useCallback } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { SectionsEnum } from '../../../helpers/utils';
import { useGetShopItemsPark } from '../../../hooks/useGetShopItemsPark';
import { useModalParkStore } from '../../../store/park/modalParkStore';
import { useModalServicesStore } from '../../../store/services/modalServicesStore';
import { useModalShoppingStore } from '../../../store/shopping/modalShoppingStore';
import {
    CartValuesServiceStore,
    useShoppingCartStore,
} from '../../../store/shoppingCart/shoppingCartStore';

export function useModalParkLogic() {
    const matchQuery = useMediaQuery('(min-width: 768px)');

    const { isVisible, setIsVisiblePark } = useModalParkStore();
    const {
        cartIsVisible,
        currentDate,
        setCurrentDate,
        setCartValues,
        setCartIsVisible,
    } = useShoppingCartStore();
    const { setIsVisibleServices } = useModalServicesStore();
    const { setIsVisibleShoppingWave } = useModalShoppingStore();

    const setModalIsVisible = useCallback(
        (visibility?: boolean) => {
            setIsVisiblePark(visibility ? visibility : !isVisible);
        },
        [isVisible, setIsVisiblePark]
    );

    const setCurrentSectionHandle = useCallback(
        (section?: string) => {
            if (section === SectionsEnum.SECTIONS) {
                setIsVisiblePark(false);
                setIsVisibleShoppingWave(true);
            }
        },
        [setIsVisibleShoppingWave, setIsVisiblePark, setIsVisibleServices]
    );

    const handleAddToCart = useCallback(
        (cartCurrentValue: CartValuesServiceStore) => {
            setCartValues(cartCurrentValue);
            if (!cartIsVisible) {
                setCartIsVisible(true);
            }
        },
        [cartIsVisible, setCartIsVisible, setCartValues]
    );

    const { data: parkDatas, isPending } = useGetShopItemsPark({
        Date: currentDate,
    });

    return {
        parkDatas,
        isPending,
        matchQuery,
        currentDate,
        cartIsVisible,
        isVisible,
        setModalIsVisible,
        setCartIsVisible,
        setCurrentSectionHandle,
        handleAddToCart,
        setCurrentDate,
    };
}
